import RectangularSticker from "./RectangularSticker";
import ElongatedSticker from "./ElongatedSticker";
import RoundSticker from "./RoundSticker";
import RectangularSmallSticker from "./RectangularSmallSticker";
import BagLabelSticker from "./BagLabelSticker";
import KeyLabelSticker from "./KeyLabelSticker";

export default class StickerBuilder {
    getByType(type, settings) {
        let sticker = null;

        switch (type) {
            case 'rectangular':
                sticker = new RectangularSticker(settings);
                break;
            case 'round':
                sticker = new RoundSticker(settings);
                break;
            case 'elongated':
                sticker = new ElongatedSticker(settings);
                break;
            case 'rectangular_small':
                sticker = new RectangularSmallSticker(settings);
                break;
            case 'bag_configurator':
                sticker = new BagLabelSticker(settings);
                break;
            case 'key_configurator':
                sticker = new KeyLabelSticker(settings);
                break;
            default:
                throw new Error(`The current type ${type} was not found`);
        }

        return sticker;
    }
}
